export type cashflowCategoriesType = 'CREDIT' | 'DEBIT' | 'INVESTMENT';

export enum DashboardAssetType {
  BANKS = 'BANKS',
  STOCKS = 'STOCKS',
  MUTUAL_FUNDS = 'MUTUAL_FUNDS',
  FD = 'FIXED_DEPOSIT',
  EPFO = 'EPFO',
  NPS = 'NPS',
}

export enum AssetCategory {
  BANKS = 'BANKS',
  STOCKS = 'STOCKS',
  MUTUAL_FUNDS = 'MUTUAL_FUNDS',
  FIXED_DEPOSIT = 'FIXED_DEPOSIT',
  EPFO = 'EPFO',
  NPS = 'NPS',
}

export const FAILED_STATUSES = [
  'DATA_NOT_RETURNED_IN_TIME',
  'TIMEOUT',
  'DENIED',
];
export const cashflowAccountCategories: cashflowCategoriesType[] = [
  'CREDIT',
  'DEBIT',
  'INVESTMENT',
];
export const cashflowAccountCategoriesSpends = [
  'INCOMING',
  'EXPENSES',
  'INVESTMENT',
];
export const DEBIT_EXCLUDED_CATEGORIES = [
  'INVESTMENT_EXPENSE',
  'TRANSFER_TO_FD_RD',
  'SMALL_SAVINGS',
  'TRANSFER_OUT',
];

export const CREDIT_EXCLUDED_CATEGORIES = ['TRANSFER_IN'];
export type AccountCashflowCategoryType = 'investment' | 'credit' | 'debit';
